import { Link } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import PageCard from '../../components/ui/PageCard';
import { useAuth } from '../../hooks/useAuth';

const ReportsHub = () => {
  const { canViewMagazineReports } = useAuth();

  const cards = [
    {
      to: '/reports/pipeline',
      title: 'Pipeline',
      description: 'Proposals by status with totals for draft, sent, and signed deals.',
    },
    {
      to: '/reports/rep-performance',
      title: 'Rep performance',
      description: 'Per sales rep: proposal counts and signed revenue for the selected period.',
    },
    {
      to: '/reports/revenue',
      title: 'Revenue',
      description: 'Signed proposal revenue and paid magazine invoice totals.',
    },
    ...(canViewMagazineReports
      ? [
          {
            to: '/magazine/reports',
            title: 'Issue report',
            description: 'Per-issue advert bookings (sent and signed line items).',
          },
        ]
      : []),
  ];

  return (
  <Layout>
    <div className="mb-6">
      <h1 className="text-2xl font-semibold text-gray-900">Reports</h1>
      <p className="mt-1 text-sm text-gray-500">
        Magazine sales analytics. Use the dashboard for a quick overview.
      </p>
    </div>

    <div className="grid gap-4 sm:grid-cols-2">
      {cards.map((card) => (
        <Link key={card.to} to={card.to} className="block no-underline">
          <PageCard className="h-full transition-shadow hover:shadow-md">
            <h2 className="text-lg font-semibold text-gray-900">{card.title}</h2>
            <p className="mt-2 text-sm text-gray-600">{card.description}</p>
            <span className="mt-4 inline-block text-sm font-medium text-torch-primary">Open report →</span>
          </PageCard>
        </Link>
      ))}
    </div>
  </Layout>
  );
};

export default ReportsHub;
